<template>
  <div class="d-flex container-fluid">
    <!-- Left Content -->
    <div class="pane left-pane" :style="{ width: leftWidth + 'px' }">
      <slot name="left"></slot>
    </div>

    <!-- Splitter Bar -->
    <div class="splitter" @mousedown="startResize" @touchstart="startResize"></div>

    <!-- Right Content -->
    <div class="pane right-pane">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      initialLeftWidth: {
        type: Number,
      },
      minWidth: {
        type: Number,
        default: 100, // Minimum width for the left pane
      },
      maxWidth: {
        type: Number,
        default: 500, // Maximum width for the left pane
      },
    },

    data() {
      return {
        leftWidth: this.initialLeftWidth,
        isResizing: false,
        lastClientX: 0,
      };
    },

    methods: {
      startResize(event) {
        this.isResizing = true;
        this.lastClientX = event.type === "mousedown" ? event.clientX : event.touches[0].clientX;

        // Add event listeners
        document.addEventListener("mousemove", this.resize);
        document.addEventListener("mouseup", this.stopResize);
        document.addEventListener("touchmove", this.resize);
        document.addEventListener("touchend", this.stopResize);
      },
      resize(event) {
        if (!this.isResizing) return;

        const clientX = event.type === "mousemove" ? event.clientX : event.touches[0].clientX;
        const delta = clientX - this.lastClientX;
        this.lastClientX = clientX;

        const newLeftWidth = this.leftWidth + delta;

        // Apply min/max constraints
        if (newLeftWidth >= this.minWidth && newLeftWidth <= this.maxWidth) {
          this.leftWidth = newLeftWidth;
        }
      },
      stopResize() {
        this.isResizing = false;
        document.removeEventListener("mousemove", this.resize);
        document.removeEventListener("mouseup", this.stopResize);
        document.removeEventListener("touchmove", this.resize);
        document.removeEventListener("touchend", this.stopResize);
      },
    },
  };
</script>

<style scoped>
.container-fluid {
  padding: 0;
}
.right-pane {
  width: 100%;
}
.splitter {
  width: 5px;
  padding: 0 1px;
  background-color: #e0e0e0;
  cursor: col-resize;
  user-select: none;
}
</style>